// extracted by mini-css-extract-plugin
export default {"ToggleArrow":"ToggleArrow_ToggleArrow__1CWK9","ToggleArrow_opened":"ToggleArrow_ToggleArrow_opened__3COZT"};